import { useSetAtom } from 'jotai';
import { creatorCJSeancePayloadAtom } from './atom';

export const useOpenCreateCJSeanceModal = () =>
  useSetAtom(creatorCJSeancePayloadAtom);
